// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Cost_wrapper__lbK3N","content":"Cost_content__1Adqp"};